<template>
	<teleport to="body">
		<v-fade-transition>
			<div
				v-show="copyFeedbackOpen"
				class="inline-copy-snackbar"
				:style="pointerStyle"
			>
				<div class="d-flex flex-column align-start ga-2">
					<v-chip
						v-for="copiedTab in copyRowAddedTabs"
						:key="copiedTab.tab.uuid"
						size="x-small"
						variant="flat"
						class="ma-0 bg-valence-positive-tint text-valence-positive-ink"
					>
						<v-icon size="small" class="ms-1 pr-2"> mdi-check </v-icon>
						{{ copiedTab.tab.name }}
					</v-chip>
					<div
						v-for="skippedTab in copyRowSkippedTabs"
						:key="skippedTab.tab.uuid"
					>
						<v-chip
							size="x-small"
							variant="flat"
							class="ma-0 bg-valence-attention-tint text-valence-attention-ink"
						>
							<v-icon size="small" class="ms-1 pr-2"> mdi-block-helper </v-icon>
							{{ skippedTab.tab.name }}
						</v-chip>
						<span v-if="copyRowSkippedTabs.length" class="ms-2">
							{{ skippedTab.message }}
						</span>
					</div>
				</div>
			</div>
		</v-fade-transition>
	</teleport>
</template>

<script>
export default {
	name: "VMetadataRowCopyToast",
	components: {},
	props: {
		copyFeedbackOpen: { type: Boolean, default: false },
		copyRowResult: { type: Array, default: () => [] },
		pointerCoords: { type: Object, default: null },
	},

	emits: [],

	setup() {},

	data() {
		return {};
	},
	computed: {
		copyRowAddedTabs() {
			return this.copyRowResult
				.filter((result) => result.copiedTab !== null)
				.map((result) => {
					return { tab: result.copiedTab, message: result.message };
				});
		},
		copyRowSkippedTabs() {
			return this.copyRowResult
				.filter((result) => result.skippedTab !== null)
				.map((result) => {
					return { tab: result.skippedTab, message: result.message };
				});
		},
		pointerStyle() {
			return {
				position: "fixed",
				top: this.pointerCoords.y + 8 + "px",
				left: this.pointerCoords.x + 8 + "px",
				transform: "translate(0, -100%)",
			};
		},
	},

	methods: {},
};
</script>

<style lang="scss">
.inline-copy-snackbar {
	position: fixed;
	background: rgba(33, 33, 33, 0.9);
	color: white;
	border-radius: 6px;
	padding: 4px 8px;
	max-width: 600px;
	font-size: 12px;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
	z-index: 2500;
}
</style>
